import React from 'react'
import { OnSearchFunc } from '@scentregroup/shared/hub-components/searchable-faceted-filter'
import { DropdownOption, SortOption } from '../sort-options'
import { IFacet, IFacetSelections } from '../../types/facets'
import { LargeFacetedFilters } from './large-faceted-filters'
import { SmallFacetedFilters } from './small-faceted-filters'
import { ICategory } from '../../types/marketplace-categories'
import { ICategoryList } from './category-list'
import style from './index.module.scss'

export enum FilterType {
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
}

export interface IFacetedFiltersProps {
  category?: ICategory
  categoryListElement: React.FunctionComponentElement<ICategoryList> | undefined
  facets: IFacet[]
  facetSelections: IFacetSelections
  onSale: boolean
  hasOnSaleProducts?: boolean
  productTypeSelections: string[]
  searchParams?: string
  sort: SortOption
  sortOptions?: DropdownOption[] | undefined
  isLinked?: boolean
  onChangeFacetSelections(facetSelections: IFacetSelections): void
  onChangeOnSale(value: boolean): void
  onChangeProductTypeSelections(productTypes: string[]): void
  onChangeSort(sortOption: SortOption): void
  onClearAll(): void
  onFacetOptionSearch?: OnSearchFunc
}

export const FacetedFilters: React.FunctionComponent<
  React.PropsWithChildren<IFacetedFiltersProps>
> = ({
  category,
  categoryListElement,
  facets,
  facetSelections,
  onSale,
  hasOnSaleProducts,
  productTypeSelections,
  sort,
  sortOptions,
  isLinked = false,
  onChangeFacetSelections,
  onChangeOnSale,
  onChangeProductTypeSelections,
  onChangeSort,
  onClearAll,
  onFacetOptionSearch,
}) => {
  return (
    <>
      <div className={style.showLarge}>
        <LargeFacetedFilters
          category={category}
          categoryListElement={categoryListElement}
          facets={facets}
          facetSelections={facetSelections}
          productTypeSelections={productTypeSelections}
          isLinked={isLinked}
          onChangeFacetSelections={onChangeFacetSelections}
          onChangeProductTypeSelections={onChangeProductTypeSelections}
          onClearAll={onClearAll}
          onFacetOptionSearch={onFacetOptionSearch}
        />
      </div>
      <div className={style.showSmall}>
        <SmallFacetedFilters
          category={category}
          categoryListElement={categoryListElement}
          facets={facets}
          facetSelections={facetSelections}
          onSale={onSale}
          productTypeSelections={productTypeSelections}
          sort={sort}
          sortOptions={sortOptions}
          hasOnSaleProducts={hasOnSaleProducts}
          onChangeFacetSelections={onChangeFacetSelections}
          onChangeProductTypeSelections={onChangeProductTypeSelections}
          onChangeSort={onChangeSort}
          onClearAll={onClearAll}
          onSaleOnChange={onChangeOnSale}
          onFacetOptionSearch={onFacetOptionSearch}
        />
      </div>
    </>
  )
}

export default FacetedFilters
